module.exports = __webpack_public_path__ + "img/8.1cfa9dc5.jpg";